<popup-header text="Recommended Actions" (clickAction)="cancel()"></popup-header>

<div mat-dialog-content *ngIf="actionsLoaded">
    <div *ngFor="let action of data.$actions">
        {{ action.description }}
    </div>
</div>

<div mat-dialog-content *ngIf="!actionsLoaded">
    <loading-animation class="cl-layout-fill" size="large"></loading-animation>
</div>

<popup-button-container>
    <cas-button (clickAction)="cancel()" btnText="OK"></cas-button>
</popup-button-container>
